
const user = {
  namespaced: true, //开启命名空间
  state: {
    userInfo:{},

  },

  mutations: {
    SET_USERINFO: (state,userInfo) => {
      state.userInfo = userInfo
    },
	SET_USERINFO_DETAIL:(state,data) => {
		//data:{key:'123',value:'222'}
		state.userInfo[data.key]=data.value
	  },
  },

  actions: {
    // // 登录
    // Login({
    //   commit
    // }, userInfo) {
    //       commit('SET_TOKEN', 1)
    // },
  }
}

export default user
